import { gql } from '@apollo/client';

export default gql`
  mutation AssignOfflineTasks($input: AssignOfflineTasksInput!) {
    assignOfflineTasks(input: $input) {
      count
    }
  }
`;
